import type { z } from "zod";

import {
  type getFeedbacksResponseZod,
  RequestTypeEnum,
} from "@nlc/shared-types";
import { useQuery } from "@tanstack/react-query";

import { FEEDBACK_TOOL_TEMPLATE_DATA } from "@/features/templates/mocks/chatStories";
import { FEEDBACK_TOOL_VIDEO_TEMPLATE_DATA } from "@/features/templates/mocks/videoChatStories";
import { feedbackToolKeys } from "@/hooks/queryKeys";
import { useIsTemplate } from "@/hooks/useIsTemplate";
import apiClient from "@/lib/api/client";

export type GetFeedbackResponse = z.infer<typeof getFeedbacksResponseZod>;

export function useGetStories({
  enable,
  parentId,
}: {
  enable?: boolean | null;
  parentId: number;
}) {
  const { isTemplate, requestType } = useIsTemplate();

  return useQuery({
    enabled: !enable || isTemplate,

    queryFn: async () => {
      if (requestType === RequestTypeEnum.GRAPHIC)
        return FEEDBACK_TOOL_TEMPLATE_DATA;
      if (requestType === RequestTypeEnum.VIDEO)
        return FEEDBACK_TOOL_VIDEO_TEMPLATE_DATA;

      return await apiClient
        .url(`/stories/${parentId}/feedback-tool`)
        .get()
        .json<GetFeedbackResponse>();
    },
    queryKey: feedbackToolKeys.feedbacks(parentId),
  });
}
